<template>
  <div class="user-points">
    <div class="card total">
      <h1>
        <span>{{ points }}</span> Total de pontos
      </h1>
      <router-link :to="{ name: 'points.extract' }" tag="button" type="button"
        >ver extrato</router-link
      >
    </div>

    <div class="info-buttons">
      <router-link
        :to="{ name: 'site.points-exchange' }"
        tag="button"
        class="app-button outline"
        >TROQUE SEUS PONTOS</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-points',
  computed: {
    points() {
      return this.$store.getters.userPoints;
    },
    ranking() {
      return this.$store.state.auth.user.ranking;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-points {
  display: flex;
  align-content: center;
}

.card {
  position: relative;
  border-radius: 12px 16px;
  padding: 16px 24px;
  box-shadow: none;
  min-width: 243px;
  min-height: 144px;

  button {
    position: absolute;
    right: 24px;
    bottom: 16px;
    background: transparent;
    border: 1px solid;
    border-radius: 4px;
    padding: 6px 8px;
    margin-top: 12px;
    cursor: pointer;
    outline: 0;
  }

  &::after {
    content: '';
    background: var(--color-primary);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    top: 16px;
    right: 24px;
  }

  &.total {
    background: var(--color-secondary);
    color: #fff;
    width: 288px;

    h1 {
      margin-top: 20px;
      font-size: 1.2em;

      span {
        font-size: 2em;
        margin-right: 5px;
      }
    }

    button {
      color: #fff;
    }
  }

  &.ranking {
    background: #fff;
    margin-left: 32px;

    > p {
      font-weight: 500;
    }

    .ranking__points {
      display: flex;
      align-content: center;
      justify-content: space-between;

      .item {
        &:last-child {
          margin-right: 16px;
        }

        p:first-child {
          font-size: 1.4em;
        }
        p:last-child {
          font-size: 0.8em;
          font-weight: 300;
        }
      }
    }

    button {
      color: #a3a3a3;
    }
  }
}

.info-buttons {
  display: flex;
  flex-direction: column;
  margin-left: 32px;

  > a > button {
    height: 100%;
    width: 100%;
  }

  > button,
  a {
    height: calc(50% - 5px);
    width: 100%;

    &:first-child {
      margin-bottom: 10px;
    }
  }
}

@media (max-width: 992px) {
  .user-points {
    width: 100%;
    flex-direction: column;
  }

  .card {
    width: 100%;
    position: relative;
    border-radius: 12px 16px;
    padding: 16px 24px;
    box-shadow: none;
    min-width: 243px;
    min-height: 144px;

    &.total {
      width: 100%;
      margin: 0;
    }

    &.ranking {
      width: 100%;
      margin: 0;
      margin-top: 1em;
    }
  }

  .info-buttons {
    width: 100%;
    margin: 0;
    margin-top: 1em;
  }
}
</style>
